import * as React from "react";
import { commentStatus } from "../../pages/enums";

const CommentStatusField = (props: any) => {
  let filterStatus = commentStatus.filter((row) => row.id == props?.record?.status);

  return <span>{filterStatus[0]?.name}</span>;
};
export default CommentStatusField;
